import React, { useState, useContext, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive'
import { useRouteMatch } from 'react-router-dom';
import Markup from '../../markup';
import { device } from '../../const/device';
import Sidebar from '../Sidebar';
import {SaveIconMobile} from '../Screens/components/SaveButtons';
import BuilderContext from '../../builder/hooks/context';

import { trackGoToAccount, trackGoToCart, trackSaveState } from '../../utils/Analytics';

type BurgerType = {
  changeShareWindow?:(state:boolean) => void,
  onInfoChange?:() => void,
  onSaveBuildChange?:() => void
}

function Burger({changeShareWindow, onInfoChange, onSaveBuildChange}:BurgerType) {
  const [open, setOpen] = useState(false);
  const match = useRouteMatch();
  const { builder } = useContext(BuilderContext);
  const tabletS = useMediaQuery({ query: `(${device.tabletS})` });
  const isTablet = useMediaQuery({ query: `(${device.tablet})` });
  const [cartCount, setCartCount] = useState(null);
  const [previousCartCount, setPreviousCartCount] = useState('0');

  const hideSidebar = () => setOpen(false);

  const showInfo = () => {
    if(onInfoChange) onInfoChange();
    hideSidebar();
  }

  const showShared = () => {
    if(changeShareWindow) changeShareWindow(true);
    hideSidebar();
  }

  const onSaveBuild = () => {
    if(changeShareWindow) onSaveBuildChange();
    trackSaveState();
    hideSidebar();
  }

  const onCartClick = () => {
    window['builderOnCart'] && window['builderOnCart']();
    trackGoToCart('icon');
    hideSidebar();
  }

  const onUserAccountClick = () => {
    window['builderOnUserAccount'] && window['builderOnUserAccount']();
    trackGoToAccount();
    hideSidebar();
  }

  const isMain = match.path === "/";

  const updateCartCount = async () => {
    const cartItemsCount = window['cartItemsCount'] && await window['cartItemsCount']();
    
    if (cartItemsCount === "0" && localStorage.getItem('previousCartCount')) {
      setCartCount(localStorage.getItem('previousCartCount'));
    } else {
      setCartCount(cartItemsCount);
    }
    
    setPreviousCartCount(cartItemsCount);
    localStorage.setItem('previousCartCount', cartItemsCount);
  }

  useEffect(() => {
    const savedCartCount = localStorage.getItem('previousCartCount');
    if (savedCartCount) {
      setPreviousCartCount(savedCartCount);
    }

    updateCartCount();
  }, [builder.cnCart]);

  // Listen for cart:updated events dispatched by useExporter after add-to-cart
  useEffect(() => {
    const handleCartUpdate = () => updateCartCount();
    window.addEventListener('cart:updated', handleCartUpdate);
    return () => window.removeEventListener('cart:updated', handleCartUpdate);
  }, []);

  if (!tabletS && !isTablet) {
    return null;
  }

  return (
    <>
      <Markup.Global.Burger.Icon open={open} onClick={() => setOpen(prevState => !prevState)} themeColor={builder.membersData.colorTheme}>
        <div />
      </Markup.Global.Burger.Icon>

      <Markup.Global.Burger.Menu open={open}>
        {tabletS &&  !isMain? <Sidebar onItemClick={hideSidebar} /> : null}
        <Markup.Global.Burger.LinkList>
          {!isMain &&
            <>
              <Markup.Global.Link.LinkInfoIcon onClick={showInfo} children='Info' themeColor={'white'}/>
              <Markup.Global.Link.LinkShareIcon onClick={showShared} children='Share' themeColor={'white'}/>
              <span onClick={onSaveBuild}><SaveIconMobile/></span>
            </>
          }
          <Markup.Global.Link.LinkUserIcon onClick={onUserAccountClick} children='Account' themeColor={'black'}/>
          <Markup.Global.Link.LinkCartIcon onClick={onCartClick} children='Cart' themeColor={'white'} count={cartCount !== null ? cartCount : previousCartCount}/>
        </Markup.Global.Burger.LinkList>
      </Markup.Global.Burger.Menu>
      <Markup.Global.Burger.Layout open={open} onClick={() => setOpen(false)} />
    </>
  );
}

export default React.memo(Burger);
